import { render, staticRenderFns } from "./ReviewAccordion.vue?vue&type=template&id=e4d5755a&scoped=true&lang=pug&"
import script from "./ReviewAccordion.vue?vue&type=script&lang=js&"
export * from "./ReviewAccordion.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAccordion.vue?vue&type=style&index=0&id=e4d5755a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d5755a",
  null
  
)

export default component.exports